import { render, staticRenderFns } from "./TpmAnalyticsProduction.vue?vue&type=template&id=3dc0c163&scoped=true"
import script from "./TpmAnalyticsProduction.vue?vue&type=script&lang=ts"
export * from "./TpmAnalyticsProduction.vue?vue&type=script&lang=ts"
import style0 from "./TpmAnalyticsProduction.vue?vue&type=style&index=0&id=3dc0c163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc0c163",
  null
  
)

export default component.exports